import PropTypes from 'prop-types'
import React from 'react'
import Spinner from 'components/Spinner'
import Ellipsis from './Ellipsis'

const Loader = ({ type, ...props }) => {
  if (type === 'spinner') return <Spinner {...props} />

  return <Ellipsis {...props} />
}

Loader.defaultProps = {
  type: 'spinner',
}

Loader.propTypes = {
  type: PropTypes.oneOf(['ellipsis', 'spinner']).isRequired,
}

export default Loader
